// components/AboutFormBuilder/AboutFieldEditDialog.jsx
import React from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Select, MenuItem, FormControl,
  InputLabel, Switch, FormControlLabel, CircularProgress
} from "@mui/material";
import { Typography } from "@mui/material";

const FIELD_TYPES = [
  { value: "singleline", label: "Single Line Text" },
  { value: "multiline", label: "Multi Line Text" },
  { value: "richtext", label: "Rich Text" },
  { value: "select", label: "Select (Dropdown)" },
  { value: "number", label: "Number" },
  { value: "date", label: "Date" },
  { value: "datetime", label: "Date & Time" },
  { value: "checkbox", label: "Checkbox" },
  { value: "email", label: "Email" },
  { value: "phone", label: "Phone Number" },
  { value: "file", label: "File Upload" }
];

const AboutFieldEditDialog = ({ 
  open, 
  onClose, 
  field,
  onFieldUpdated, 
  isLoading,
  fieldData,
  setFieldData 
}) => {
  const handleUpdate = () => {
    onFieldUpdated(fieldData);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ borderBottom: '1px solid #e2e8f0', pb: 2 }}>
        <Typography variant="h6" fontWeight={600}>
          Edit Field
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ pt: 3 }}>
        <TextField
          fullWidth
          label="Label"
          value={fieldData.label}
          onChange={(e) => setFieldData({ ...fieldData, label: e.target.value })}
          margin="normal"
          required
          sx={{
            '& .MuiInputBase-input': { fontSize: '0.9rem' }
          }}
        />
        <FormControl fullWidth margin="normal">
          <InputLabel>Field Type</InputLabel>
          <Select
            value={fieldData.field_type}
            onChange={(e) => setFieldData({ ...fieldData, field_type: e.target.value })}
            label="Field Type"
            sx={{
              '& .MuiInputBase-input': { fontSize: '0.9rem' }
            }}
          >
            {FIELD_TYPES.map((type) => (
              <MenuItem key={type.value} value={type.value}>
                {type.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          fullWidth
          label="Placeholder"
          value={fieldData.placeholder}
          onChange={(e) => setFieldData({ ...fieldData, placeholder: e.target.value })}
          margin="normal"
          sx={{
            '& .MuiInputBase-input': { fontSize: '0.9rem' }
          }}
        />
        <TextField
          fullWidth
          label="Help Text"
          value={fieldData.help_text}
          onChange={(e) => setFieldData({ ...fieldData, help_text: e.target.value })}
          margin="normal"
          sx={{
            '& .MuiInputBase-input': { fontSize: '0.9rem' }
          }}
        />
        {fieldData.field_type === 'select' && (
          <TextField
            fullWidth
            label="Choices (comma separated)"
            value={fieldData.choices}
            onChange={(e) => setFieldData({ ...fieldData, choices: e.target.value })}
            margin="normal"
            helperText="e.g., Male, Female, Other"
            sx={{
              '& .MuiInputBase-input': { fontSize: '0.9rem' }
            }}
          />
        )}
        <FormControlLabel
          control={
            <Switch
              checked={fieldData.required}
              onChange={(e) => setFieldData({ ...fieldData, required: e.target.checked })}
            />
          }
          label="Required"
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions sx={{ borderTop: '1px solid #e2e8f0', p: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button 
          onClick={handleUpdate}
          variant="contained"
          disabled={isLoading}
          sx={{
            background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
            textTransform: 'none',
            '&:hover': {
              transform: 'translateY(-1px)'
            }
          }}
        >
          {isLoading ? <CircularProgress size={24} /> : "Update Field"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AboutFieldEditDialog;